import { Component, OnInit } from '@angular/core';
import { BrokerGroupTableConfig } from "./broker-group-list.table-config";
import { BrokerAdminService, BrokerGroupService } from '@app/services';

@Component({
  selector: 'app-broker-group-list',
  templateUrl: './broker-group-list.component.html',
  styleUrls: ['./broker-group-list.component.scss']
})
export class BrokerGroupListComponent implements OnInit {
  panelVisible: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  editSelected: any = null;

  constructor(
    private brokerGroupService: BrokerGroupService
  ) { }

  ngOnInit(): void {
    this.config = BrokerGroupTableConfig.configure();
    this.getList();
  }

  getList() {
    this.brokerGroupService.list().subscribe({
      next: (res: any) => {
        this.dataSource = res.data
      }
    })
  }

  action(e: any) {
    this.editSelected = null;
    if(e.button.eventName == "edit") {
      this.editSelected = e.data
      this.panelVisible = true;
    }
    if(e.button.eventName == "add") {
      this.panelVisible = true;
    }
  }

  onPopupclose() {
    this.panelVisible = false
    this.editSelected = null;
    this.getList();
  }

}
